import type { FC } from 'react';

import { Placeholder, useRendering } from '@eneco/cms';
import { Box, PageGrid } from '@eneco/sparky';

import { FOOTER_SLOTS, resolveSlot } from './slots';

/**
 * `Footer` block for the CMS-agnostic lane, serving **both** providers. Carries no fields of its own on
 * either provider — purely a structural container for its named regions, same role as `MainNavigation`.
 *
 * Follows the legacy component's own structure (`libs/sitecore/components/content/src/Footer/
 * Footer.tsx`): navigation on the page background, then the subfooter on `backgroundSecondary`, split
 * into two columns from `md` up. `PageGrid` is what aligns it to the page's content columns —
 * `CmsLayout` deliberately puts the footer outside its own grid so chrome can span the full width and
 * bring its own.
 */
const Footer: FC = () => {
  const rendering = useRendering();

  const navigationSlot = resolveSlot(rendering, FOOTER_SLOTS.navigation);
  const subfooterLeftSlot = resolveSlot(rendering, FOOTER_SLOTS.subfooterLeft);
  const subfooterRightSlot = resolveSlot(rendering, FOOTER_SLOTS.subfooterRight);

  return (
    <Box backgroundColor="backgroundPrimary">
      {navigationSlot && (
        <PageGrid>
          <PageGrid.Item gridColumn="1/-1">
            <Placeholder name={navigationSlot} />
          </PageGrid.Item>
        </PageGrid>
      )}
      <Box backgroundColor="backgroundSecondary" paddingTop={{ initial: '24', xl: '32' }} paddingBottom={{ initial: '6', md: '10' }}>
        <PageGrid>
          <PageGrid.Item gridColumn={{ initial: '1/-1', md: '1/7' }}>
            <Box paddingBottom={{ initial: '5', md: '0' }}>{subfooterLeftSlot && <Placeholder name={subfooterLeftSlot} />}</Box>
          </PageGrid.Item>
          <PageGrid.Item gridColumn={{ initial: '1/-1', md: '7/13' }}>
            {subfooterRightSlot && <Placeholder name={subfooterRightSlot} />}
          </PageGrid.Item>
        </PageGrid>
      </Box>
    </Box>
  );
};

export default Footer;
